import terms1 from '../../../src/assets/images/severnet-user-agreement/1.jpg'
import terms2 from '../../../src/assets/images/severnet-user-agreement/2.jpg'
import terms3 from '../../../src/assets/images/severnet-user-agreement/3.jpg'
import terms4 from '../../../src/assets/images/severnet-user-agreement/4.jpg'
import terms5 from '../../../src/assets/images/severnet-user-agreement/5.jpg'
import terms6 from '../../../src/assets/images/severnet-user-agreement/6.jpg'
const TermsViewer = ()=> {

  const pages = [terms1,terms2,terms3,terms4,terms5,terms6]

  return (
    <div
      style={{
        height:'100%',
        overflow: "scroll",
      }}
    >
      {pages.map((src, index) => (
        <img
          key={index}
          src={src}
          loading="lazy"
          alt={`Terms page ${index + 1}`}
          style={{
            width: "100%",
            display: "block",
          }}
        />
      ))}
    </div>
  );
}
export default TermsViewer